import { render, staticRenderFns } from "./ho_user_allocation.vue?vue&type=template&id=4f1b1094"
import script from "./ho_user_allocation.vue?vue&type=script&lang=js"
export * from "./ho_user_allocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports